import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { staggerRevealOnScroll } from '../../utils/animations';
import styles from './Testimonials.module.scss';

const testimonials = [
  {
    quote: "Rashika transformed our digital presence. Within 3 months, our organic lead volume doubled, and our cost per acquisition dropped significantly.",
    author: "Amit Sharma",
    role: "Founder, TechFlow Solutions",
    initials: "AS"
  },
  {
    quote: "Her understanding of Local SEO is unmatched. We went from being invisible on Google Maps to dominating the top 3 spots for all our core services.",
    author: "Sarah Jenkins",
    role: "Marketing Director, Zenith Retail",
    initials: "SJ"
  },
  {
    quote: "A highly professional approach. The CRM integrations and video design support they structured helped us convert twice as many prospects.",
    author: "Rajesh Patel",
    role: "Operations Lead, Apex Ventures",
    initials: "RP"
  }
];

const Testimonials: React.FC = () => {
  const gridRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Rely on pure CSS stagger animations for rendering reliability
  }, []);

  return (
    <section className={styles.testimonialsSection}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.sectionTitle}>Client <span className={styles.highlight}>Reviews</span></h2>
        </div>
        
        <div ref={gridRef} className={styles.grid}>
          {testimonials.map((test, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.quoteIcon}>"</div>
              <p className={styles.quote}>{test.quote}</p>
              <div className={styles.authorInfo}>
                <div className={styles.avatarPlaceholder}>{test.initials}</div>
                <div className={styles.authorDetails}>
                  <div className={styles.authorName}>{test.author}</div>
                  <div className={styles.authorRole}>{test.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
